export { PublicationEditPage as default, getServerSideProps } from 'modules/publication/pages/PublicationEditPage'
